<template>
  <v-form ref="changeProfileForm" @submit.prevent="changeProfile">
    <v-card-title>
      Profile
    </v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <p><strong>ID: </strong>{{ Id }}</p>
        </v-col>
        <v-col cols="12">
          <p><strong>Email: </strong>{{ Email }}</p>
        </v-col>
        <v-col cols="12">
          <p>
            <strong>Email Status: </strong>
            <strong :class="{
                      'error--text': !IsConfirmed,
                      'success--text': IsConfirmed
                    }">
              <span v-if="IsConfirmed">Confirmed!</span>
              <span v-else>Not yet confirmed</span>
            </strong>
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field label="First Name"
                        maxlength="64"
                        v-if="canEdit"
                        v-model="model.FirstName"
                        :rules="rules.FirstName" />
          <p v-else><strong>First Name: </strong>{{ FirstName }}</p>
        </v-col>
        <v-col cols="12">
          <v-text-field label="Last Name"
                        maxlength="64"
                        v-if="canEdit"
                        v-model="model.LastName"
                        :rules="rules.LastName" />
          <p v-else><strong>Last Name: </strong>{{ LastName }}</p>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="px-4 pb-4"
                    v-if="canEdit">
      <v-btn large ripple link
             type="submit"
             color="primary">
        Update Profile
      </v-btn>
      <v-btn large ripple link
             color="info"
             :disabled="IsConfirmed"
             @click="confirmEmail">
        Resend Confirmation
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'ChangeProfile',
  props: {
    Id: String,
    FirstName: String,
    LastName: String,
    Email: String,
    IsConfirmed: Boolean,
  },
  data() {
    return {
      model: {
        FirstName: this.FirstName,
        LastName: this.LastName,
      },
      rules: {
        FirstName: [
          (v) => rules.required(v, 'First Name is required'),
        ],
        LastName: [
          (v) => rules.required(v, 'Last Name is required'),
        ],
      },
    };
  },
  computed: {
    isMine() {
      if (!this.$route.params.id) {
        return true;
      }
      return this.Id === this.$store.getters.user.id;
    },
    canEdit() {
      return this.isMine || this.$store.getters.can('Admin');
    },
  },
  methods: {
    async changeProfile() {
      if (this.$refs.changeProfileForm.validate()) {
        try {
          this.loading = true;
          await this.$store.dispatch('patch', {
            api: `User/${this.Id}`,
            data: this.model,
          });
          this.$emit('snackbar', 'Profile successfully updated!');
        } catch (e) {
          // Do nothing
        }
        this.loading = false;
      }
    },
    async confirmEmail() {
      const whose = this.isMine ? 'your' : `${this.Email}'s`;
      await this.$store.dispatch('get', {
        api: 'User/Confirm',
        params: { id: this.Id },
      });
      this.$emit('snackbar', `An email has been sent to ${whose} inbox.`);
    },
  },
};
</script>
